/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An MCP server the signed-in user hid.
 */
export type HiddenMcpServer = {
  /**
   * When the user hid the server.
   */
  hiddenAt: Date;
  /**
   * The hidden MCP server.
   */
  mcpServerId: string;
  /**
   * The server's display name, when it has one.
   */
  name?: string | undefined;
  /**
   * The server's project.
   */
  projectId: string;
  /**
   * The server's project slug.
   */
  projectSlug: string;
  /**
   * The server's slug, when it has one.
   */
  slug?: string | undefined;
};

/** @internal */
export const HiddenMcpServer$inboundSchema: z.ZodMiniType<
  HiddenMcpServer,
  unknown
> = z.pipe(
  z.object({
    hidden_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    mcp_server_id: z.string(),
    name: z.optional(z.string()),
    project_id: z.string(),
    project_slug: z.string(),
    slug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "hidden_at": "hiddenAt",
      "mcp_server_id": "mcpServerId",
      "project_id": "projectId",
      "project_slug": "projectSlug",
    });
  }),
);

export function hiddenMcpServerFromJSON(
  jsonString: string,
): SafeParseResult<HiddenMcpServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => HiddenMcpServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'HiddenMcpServer' from JSON`,
  );
}
